module.exports = __webpack_public_path__ + "66273c6831cdfc8a64d92cea4730ce15.pdf";